import React, { useRef, useState } from 'react'
import { useSelector } from 'react-redux'
import { Translate } from '../../../language'
import Button from '../../../utils/components/Button/Button'
import Input from '../../../utils/components/Input/Input'
import { UploadImage } from '../../../components/Register/UploadFile'
import circle from '../../../assets/img/circulogris.png';
import './RequestRepresentative.css'
import { usePlaces } from '../../../utils/hooks/usePlaces';
import File from '../../../utils/components/File/File'
import style from './RequestEcoTiendaOrMaster.module.css'
import localStorage from '../../../utils/hooks/useLocalStorage'

const RequestRepresentative = ({ formik, tittle = "", isEcoTienda = false }) => {

    usePlaces(formik.values.businessCountry, formik.values.businessDepartment)
    const { countries, states, cities } = useSelector(state => state.locations)
    const [picture, setPicture] = useState(null);


    const chamberOfCommerceRef = useRef(null);
    const bankCertificationRef = useRef(null);
    const commercialReferenceRef = useRef(null);
    return (
        <div className="">
            <div className="title-register">{tittle}</div>
            <div className="content-request-franchisee">
                {!isEcoTienda && (
                    <div>

                        <div className={`row centerItems`}>
                            <UploadImage
                                classNameUpload={style.upload_image}
                                picture={picture}
                                setPicture={setPicture}
                                setFile={(value) => { formik.setFieldValue("picture", value) }}
                            />
                        </div>

                        <div className={style.form_container}>
                            <div className={`text-error-input`}>{formik.errors.picture}</div>
                        </div>

                    </div>


                )
                }
                {
                    isEcoTienda && <div className="content-picture-request-franchisee">
                        {localStorage().getItem("picturProfile") ? <img alt="img" className="img-request-franchisee" onError={(e) => e.target.src = circle} src={localStorage().getItem("picturProfile")}></img> :
                            <img alt="img" className="img-request-franchisee" src={circle}></img>}
                    </div>
                }
                <div className="content-data-request-franchisee">
                    <div className="content-inputs-request-franchisee">
                        <div className='' >
                            <select className='input-select-style' name="kindOfPerson" value={formik.values.kindOfPerson} onChange={formik.handleChange}>
                                <option value="">Seleccione el tipo de persona</option>
                                <option value="natural">Natural</option>
                                <option value="juridica">Jurídica</option>
                                <option value="comerciante">Comerciante</option>
                            </select>
                        </div>
                        {
                            isEcoTienda && (
                                <div className='' >
                                    <select className='input-select-style' name="category" value={formik.values.category} onChange={formik.handleChange}>
                                        <option value="">Categoría</option>
                                        <option value="tienda">Tienda</option>
                                        <option value="innovador">Innovador</option>
                                        <option value="comun">Común</option>
                                    </select>
                                </div>
                            )
                        }

                        <Input
                            name="socialReason"
                            type="text"
                            placeholder={'*Razón social'}
                            value={formik.values.socialReason}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={formik.errors.socialReason}
                        />
                        <div className='input-select-style-container'>
                            <select className='input-select-style' name="businessCountry" value={formik.values.businessCountry} onChange={formik.handleChange}>
                                <option value="">País</option>
                                {countries.map((country) => (
                                    <option key={country.countryID} value={country.countryName}>
                                        {country.countryName}
                                    </option>
                                )
                                )}
                            </select>
                        </div>
                        <div className='input-select-style-container'>
                            <select className='input-select-style' name="businessDepartment" value={formik.values.businessDepartment} onChange={formik.handleChange}>
                                <option value="">Departamento</option>
                                {states.map((state) => (
                                    <option key={state.stateID} value={state.stateName}>
                                        {state.stateName}
                                    </option>
                                )
                                )}
                            </select>
                        </div>

                        <div className='input-select-style-container'>
                            <select className='input-select-style' name="businessCity" value={formik.values.businessCity} onChange={formik.handleChange}>
                                <option value="">Ciudad</option>
                                {cities.map((city) => (
                                    <option key={city.cityID} value={city.cityName}>
                                        {city.cityName}
                                    </option>
                                )
                                )}
                            </select>
                        </div>
                        <Input
                            name="businessLocation"
                            type="text"
                            placeholder={'*Ubicación del negocio'}
                            value={formik.values.businessLocation}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={formik.errors.businessLocation}
                        />
                        <Input
                            name="businessAddress"
                            type="text"
                            placeholder={'*Dirección del negocio'}
                            value={formik.values.businessAddress}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={formik.errors.businessAddress}
                        />
                        <Input
                            name="businessEmail"
                            type="text"
                            placeholder={'*Correo del negocio'}
                            value={formik.values.businessEmail}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={formik.errors.businessEmail}
                        />
                        <Input
                            name="businessPhone"
                            type="text"
                            placeholder={'*Numero de telefono'}
                            value={formik.values.businessPhone}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={formik.errors.businessPhone}
                        />
                        <Input
                            name="reasonForRequest"
                            type="text"
                            placeholder={!isEcoTienda ? "Por que razón quieres ser Ecotienda de nuestra marca":"Por que razón quieres ser Ecomaster de nuestra marca"}
                            value={formik.values.reasonForRequest}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={formik.errors.reasonForRequest}
                        />
                        {
                            (formik.values.kindOfPerson === "juridica" || formik.values.kindOfPerson === "comerciante") && (<>
                                <File
                                    name="rut"
                                    accept=".pdf"
                                    text={formik.values.rut ? "Archivo cargado" : "*Carge el soporte de rut"}
                                    onChange={(event) => formik.setFieldValue("rut", event.target.files[0])}
                                />
                                <File
                                    name="chamberOfCommerce"
                                    accept=".pdf"
                                    text={formik.values.chamberOfCommerce ? "Archivo cargado" : "*Carge el soporte de la camara de comercio"}
                                    onChange={(event) => formik.setFieldValue("chamberOfCommerce", event.target.files[0])}
                                />
                                <File
                                    name="chamberOfCommerce"
                                    accept=".pdf"
                                    text={formik.values.bankCertification ? "Archivo cargado" : "*Carge el soporte de la certificacion Bancaria"}
                                    onChange={(event) => formik.setFieldValue("bankCertification", event.target.files[0])}
                                />
                                <File
                                    name="commercialReference"
                                    accept=".pdf"
                                    text={formik.values.commercialReference ? "Archivo cargado" : "Carge el archivo de la referencia comercial"}
                                    onChange={(event) => formik.setFieldValue("commercialReference", event.target.files[0])}
                                />
                            </>)}
                    </div>
                    <Button onClick={formik.handleSubmit} classNameContent={"button-save-request-franchisee"} text={Translate('send', 'es')} theme="white" />
                </div>
            </div>
        </div>
    )
}

export default RequestRepresentative
